import React, { useEffect, useState } from "react";
import { IconType } from "react-icons";
import { MdAvTimer, MdHourglassTop, MdOutlineTextsms } from "react-icons/md";
import ModalProps from "@ltypes/modalProps";
import Product from "@ltypes/product";
import Flash from "@ltypes/flash";
import SceneType from "@enums/sceneType";
import Modal from "@components/modals/Modal/Modal";
import Button from "@components/forms/Button/Button";
import TimerFlash from "@components/flashs/TimerFlash/TimerFlash";
import PomodoroFlash from "@components/flashs/PomodoroFlash/PomodoroFlash";
import TextFlash from "@components/flashs/TextFlash/TextFlash";
import Loader from "@components/ui/Loader/Loader";
import ProductService from "@services/ProductService";
import './MakeAFlash.scss';

type MakeAFlashProps = {
    product?: Product,
    onCreate: (flash: Flash) => void,
} & ModalProps;

type FlashItem = {
    sceneType: number,
    label: string,
    icon: IconType,
};

function MakeAFlash(props: MakeAFlashProps) {
    const [selected, setSelected] = useState<number|null>(null);
    const [isLoading, setLoading] = useState<boolean>(false);

    const service = new ProductService;
    
    const items: Array<FlashItem> = [
        {
            sceneType: 5,
            label: 'Minuteur',
            icon: MdHourglassTop,
        },
        {
            sceneType: 6,
            label: 'Pomodoro',
            icon: MdAvTimer,
        },
        {
            sceneType: 1,
            label: 'Text',
            icon: MdOutlineTextsms,
        },
        // {
        //     sceneType: 6,
        //     label: 'Chronomètre',
        //     icon: MdOutlineTimer,
        // },
        // {
        //     sceneType: 7,
        //     label: 'Pomodoro',
        //     icon: MdAvTimer,
        // },
        // {
        //     sceneType: 8,
        //     label: 'Text',
        //     icon: MdOutlineTextsms,
        // },
    ];

    const handleBack = () => {
        setSelected(null);
    };

    const handleClick = (flash: FlashItem) => {
        setSelected(flash.sceneType);
    };

    const startFlash = (formData: {[label: string]: any}) => {
        if(!props.product)
            return;
        // props.onHide();

        setLoading(true);
        service.createSceneFlash(props.product.id, {
            type: selected,
            ...formData,
        }).then((data: any) => {
            const newFlash: Flash = data.body;
            props.onCreate(newFlash);
        }).finally(() => {
            setSelected(null);
            setLoading(false);
            props.onHide();
        });
    };

    useEffect(() => {
        if(props.visible) {
            setSelected(null);
            setLoading(false);
        }
    }, [props.visible]);

    return (
        <Modal className="modal-makeaflash" visible={props.visible} onHide={props.onHide}>
            {selected !== null && (
                <div className="mb-3">
                    <Button size="sm" onClick={handleBack} disabled={isLoading}>&lt; Back</Button>
                </div>
            )}

            {selected === null ? (
                <div className="flash-container">
                    {items.map((flash: FlashItem) => (
                        <span key={flash.sceneType} className="flash-item" onClick={() => handleClick(flash)}>
                            <span className="flash-item-icon">
                                {React.createElement(flash.icon)}
                            </span>
                            <span className="flash-item-label">{flash.label}</span>
                        </span>
                    ))}
                </div>
            ) : isLoading ? (
                <Loader size="2.5rem" noMargin/>
            ) : selected === SceneType.TIMER ? (
                <TimerFlash onStart={startFlash}/>
            ) : selected === SceneType.POMODORO ? (
                <PomodoroFlash onStart={startFlash}/>
            ) : selected === SceneType.TEXT ? (
                <TextFlash onStart={startFlash}/>
            ) : <></>}
        </Modal>
    );
}

export default MakeAFlash;
